import React, { Component } from 'react'

import { constructError } from '../../services/errors.js'

import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import FormHelperText from '@material-ui/core/FormHelperText'

export default class ProductPrices extends Component {
  state = {}

  changePrice = (type, source) => e => {
    this.props.changePrice(type, source, e.target.value)
  }

  renderPrices(sources, type, adornment) {
    const { errors, prices } = this.props
    const typeErrors = errors && errors[type]

    return (
      <Grid container item spacing={16} key={type} xs={12}>
        {sources.map((source, index) => (
          <Grid item xs={4} sm={3} key={index}>
            <FormControl
              margin="normal"
              fullWidth
              error={typeErrors && typeErrors[source.id] !== undefined}
            >
              <InputLabel htmlFor="price">{source.technicalLabel}</InputLabel>
              <Input
                id="price"
                value={prices && prices[type][source.id]}
                onChange={this.changePrice(type, source.id)}
                type="number"
                startAdornment={
                  <InputAdornment position="start">{adornment}</InputAdornment>
                }
              />
              <FormHelperText>
                {typeErrors && constructError(typeErrors[source.id])}
              </FormHelperText>
            </FormControl>
          </Grid>
        ))}
      </Grid>
    )
  }
  render() {
    const { grid, periods } = this.props
    return grid !== undefined || periods !== undefined ? (
      <Grid container spacing={8}>
        <Typography variant="h4">Gestion des prix</Typography>
        {this.renderPrices(grid, 'grid', '€')}
        {this.renderPrices(periods, 'periods', '%')}
      </Grid>
    ) : (
      <div>Pas de prix</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/products/ProductPrices.js